module.exports = __webpack_public_path__ + "img/u36.6ce96b04.png";